import { useTelescopeContext } from "@hubble/telescope";
import { createJob } from "~/utils/job";
import { showSnackBar } from "~/shared_states/snackbar";
import { closeAllModals, goBack } from "~/shared_states/modal";
import { clientRepo } from "~/server/apis/client_repo";
import { clearCookie } from "~/utils/client_cookie";
import { Cookie } from "~/types";

export function LogoutConfirmationModal(props: { onLogout: () => void }) {
  const { components } = useTelescopeContext();

  const logoutJob = createJob<void>({
    successCallback: async () => {
      await closeAllModals();
      // todo: ensure this happens only for rnr mode
      props.onLogout();
    },
    errorCallback: (error) => {
      console.error("Logout failed:", error);
      showSnackBar({
        level: "error",
        message: error.message || "Failed to logout. Please try again.",
      });
    },
  });

  const handleLogout = () => {
    logoutJob.setJob(async () => {
      // Minimum 500ms to avoid flash effect
      const [result] = await Promise.all([
        (async () => {
          await clientRepo.logout();
          clearCookie(Cookie.SessionId);
        })(),
        new Promise((resolve) => setTimeout(resolve, 500)),
      ]);
      return result;
    });
    logoutJob.run();
  };

  return (
    <div class="flex w-full flex-col ">
      {/* Modal Header */}
      <components.ModalHeader
        size="large"
        title="Are you sure?"
        // icon={() => <LogoutIconUrl />}
        onClose={() => goBack()}
      />

      {/* Modal Footer */}
      <components.ModalFooter
        leftButton={{
          text: "Cancel",
          onClick: () => goBack(),
          variant: "secondary",
          style: "neutral",
          size: 40,
          disabled: logoutJob.isRunning(),
          expanded: true,
        }}
        rightButton={{
          text: "Log out",
          onClick: handleLogout,
          variant: "primary",
          style: "neutral",
          size: 40,
          loading: logoutJob.isRunning(),
          disabled: logoutJob.isRunning(),
          expanded: true,
        }}
      />
    </div>
  );
}

function LogoutIconUrl() {
  // Create a data URL for the logout icon with red background
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" fill="none">
        <circle cx="30" cy="30" r="29.5" fill="#F7F7F7" stroke="#EBEBEB" />
      </svg>
    </>
  );
}
